export default __webpack_public_path__ + "static/media/RegolamentoMiliscola2021.3243d034.pdf";